// Matches MediaService._allowedMediaExtensions[MediaType.VIDEO] in Neo-backend —
// audio files are uploaded under MediaType.VIDEO too (the shared Media model has
// no AUDIO variant; AudioVideoContent.contentType carries the real distinction).
export const ALLOWED_MEDIA_EXTENSIONS = ["mov", "wav", "mp4", "avi", "flv", "webm"];

// Matches MediaService._allowedMediaExtensions[MediaType.IMAGE] in Neo-backend —
// deliberately not the narrower shared src/constants/ImageTypes.js list (missing
// bmp/gif), which would reject uploads the backend actually accepts.
export const ALLOWED_IMAGE_EXTENSIONS = ["png", "jpg", "bmp", "jpeg", "gif"];

// Background music for a built-in reset. Uploaded as MediaType.VIDEO like all
// audio; matches BACKGROUND_MUSIC_EXTENSIONS in Neo-backend's
// built_in_activity_content.constants.ts, which also checks it on save.
export const ALLOWED_MUSIC_EXTENSIONS = ["mp3", "m4a", "aac", "wav", "ogg"];

export const CONTENT_TYPE_OPTIONS = [
    { value: "AUDIO", label: "Audio" },
    { value: "VIDEO", label: "Video" },
];

// Must match MindCircuit's StateKey union exactly (mindcircuit-app/src/
// components/home/stateContent.tsx) and Neo-backend's HomeStateKey enum —
// the 5 home-screen state cards a piece of content is uploaded onto.
export const STATE_KEY_OPTIONS = [
    { value: "calm", label: "Calm" },
    { value: "focus", label: "Focus" },
    { value: "clarity", label: "Clarity" },
    { value: "energy", label: "Energy" },
    { value: "comfort", label: "Comfort" },
];

// The 3 states MindCircuit shows an unlimited, unordered list of
// admin-uploaded content for — see MindCircuit's videoActivityContent.ts
// VIDEO_STATES, which this must match exactly.
export const VIDEO_STATE_KEYS = ["clarity", "energy", "comfort"];

// Calm and Focus are different: MindCircuit always shows exactly 3 cards
// there, and the first is permanently the built-in game/breathing session —
// never editable, never removable (see MindCircuit's activityContent.ts).
// Content uploaded onto calm/focus fills one of the *other two* cards, so it
// must say which — 1 or 2. Must match Neo-backend's
// AudioVideoContentService.SLOT_ELIGIBLE_STATES exactly.
export const SLOT_ELIGIBLE_STATE_KEYS = ["calm", "focus"];

export const ACTIVITY_SLOT_OPTIONS = [
    { value: 1, label: "Card 2 (the first editable card — card 1 is always the built-in activity)" },
    { value: 2, label: "Card 3 (the second editable card)" },
];

// My Resets' quick timing/context filters — which situations this activity
// suits, multi-select. Must match Neo-backend's ResetContext enum exactly.
export const RESET_CONTEXT_OPTIONS = [
    { value: "TRANSITION", label: "Transition time" },
    { value: "AFTER_LUNCH", label: "After lunch" },
    { value: "BEFORE_TEST", label: "Before a test" },
    { value: "MORNING_MEETING", label: "Morning meeting" },
    { value: "RETURN_FROM_RECESS", label: "Return from recess" },
];
